import React from "react";
import { PartnerDetailType } from "../../../../../../redux/slices/partner-details/Types";
import { useAppDispatch, useAppSelector } from "../../../../../../redux";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
  Modal,
  ModalVariants,
} from "@hid-galaxy-ui/galaxy-react";
import "./DeletePartnerModal.scss";
import { useNavigate } from "react-router";
import { deletePartnerSagaAction } from "../../../../../../redux/saga/partner-details/saga-actions";

const DeletePartnerModal: React.FC<{
  partnerDetails: PartnerDetailType;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ partnerDetails, setModalOpen }) => {
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const { status } = useAppSelector((state) => state.partner_details);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onModalClose = () => {
    setModalOpen(false);
    if (submitted && status.deletePartnerStatus)
      navigate("/hid-admin/dashboard/partner-organizations");
  };
  const onDeleteButtonClick = () => {
    dispatch(deletePartnerSagaAction(partnerDetails.ID));
		setSubmitted(true);
  };
  return (
    <Modal
      size={ModalVariants.Medium}
      onClose={() => onModalClose()}
      className="delete-partner-confirm-modal"
    >
      {submitted ? (
        <div className="status-message-modal-container">
          {status.deletePartnerLoading ? (
            <Loader variant={LoaderSizes.large} />
          ) : status.deletePartnerStatus ? (
            <>
              <Iconography
                icon="circleCheck"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Success}
              />
              <div className="message">
                Partner {partnerDetails.partner_name} deleted permanently
              </div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => onModalClose()}
              />
            </>
          ) : (
            <>
              <Iconography
                icon="circleXmark"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Error}
              />
              <div className="message">{status.deletePartnerMessage}</div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => onModalClose()}
              />
            </>
          )}
        </div>
      ) : (
        <div className="message-button-container">
          <div className="partner-name-status">
            <p>
              Please confirm that you want to delete this partner permanently
            </p>
            <div className="icon-wrapper">
              <Iconography icon="buildings" size={IconographySizes.Medium} />
            </div>
            <div className="name">{partnerDetails.partner_name}</div>
            <div className="status">{`${partnerDetails.status} Partner`}</div>
          </div>
          <div className="button-group">
            <Button
              variant="warning"
              label="Confirm And Delete"
              onClick={() => onDeleteButtonClick()}
            />
            <Button
              variant="secondary"
              label="Cancel"
              onClick={() => setModalOpen(false)}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DeletePartnerModal;
